// ==================== UNIDADES DE MEDIDA ====================
export const UNIDADES_MEDIDA = [
  // Longitud
  { value: "m", label: "m (metro)", categoria: "Longitud" },
  { value: "cm", label: "cm (centímetro)", categoria: "Longitud" },
  { value: "mm", label: "mm (milímetro)", categoria: "Longitud" },
  { value: "km", label: "km (kilómetro)", categoria: "Longitud" },
  
  // Área / Superficie
  { value: "m²", label: "m² (metro cuadrado)", categoria: "Área" },
  { value: "cm²", label: "cm² (centímetro cuadrado)", categoria: "Área" },
  { value: "ha", label: "ha (hectárea)", categoria: "Área" },
  
  // Volumen
  { value: "m³", label: "m³ (metro cúbico)", categoria: "Volumen" },
  { value: "cm³", label: "cm³ (centímetro cúbico)", categoria: "Volumen" },
  { value: "litro", label: "litro", categoria: "Volumen" },
  { value: "ml", label: "ml (mililitro)", categoria: "Volumen" },
  
  // Peso / Masa
  { value: "kg", label: "kg (kilogramo)", categoria: "Peso" },
  { value: "g", label: "g (gramo)", categoria: "Peso" },
  { value: "ton", label: "ton (tonelada)", categoria: "Peso" },
  
  // Tiempo / Mano de Obra
  { value: "hora", label: "hora", categoria: "Tiempo" },
  { value: "día", label: "día", categoria: "Tiempo" },
  { value: "mes", label: "mes", categoria: "Tiempo" },
  { value: "jornal", label: "jornal", categoria: "Tiempo" },
  
  // Cantidad / Unidades
  { value: "unidad", label: "unidad", categoria: "Cantidad" },
  { value: "pieza", label: "pieza", categoria: "Cantidad" },
  { value: "juego", label: "juego", categoria: "Cantidad" },
  { value: "par", label: "par", categoria: "Cantidad" },
  { value: "docena", label: "docena", categoria: "Cantidad" },
  
  // Materiales / Embalaje
  { value: "saco", label: "saco", categoria: "Embalaje" },
  { value: "bolsa", label: "bolsa", categoria: "Embalaje" },
  { value: "balde", label: "balde", categoria: "Embalaje" },
  { value: "tambor", label: "tambor", categoria: "Embalaje" },
  { value: "pallet", label: "pallet", categoria: "Embalaje" },
  { value: "rollo", label: "rollo", categoria: "Embalaje" },
  { value: "plancha", label: "plancha", categoria: "Embalaje" },
  { value: "pliego", label: "pliego", categoria: "Embalaje" },
  
  // Otros
  { value: "global", label: "global", categoria: "Otros" },
  { value: "%", label: "% (porcentaje)", categoria: "Otros" },
];
